import { NotificationCommunity } from "./notificationcommunity";
import { NotificationSubGroup } from "./notificationsubgroup";

export class Notification {
    public notificationId?: number;
    public notificationTypeId?: number;
    public notificationTypeName?: string; 
    public edhMarketId?: number;
    public edhContactId?: number;
    public createdBy?: string;
    public createdUtcDate?: Date;
    public lastModifiedBy?: string;
    public lastModifiedUtcDate?: Date;
    public notificationCommunities?: NotificationCommunity[] = [];
    public notificationSubGroup?: NotificationSubGroup;
}